module.exports = __webpack_public_path__ + "static/media/012.b792f70b.jpg";